<template >
  <v-app @drop="preventdrop" style="background-color:#1E242E;color:#ffffff;min-height: 100vh;">
    <div v-if="userLoaded">
      <transition name="component-fade" mode="out-in">
        <v-app-bar
          v-if="$vuetify.breakpoint.lgAndUp"
          style="padding:0px; margin:0px;border:0px;"
          fixed
          :style="isOffline ? 'background-color:#E62163': 'background-color:#28303d'"
        >
          
          <div v-if="isOffline" class="width-full text-center">
            <v-icon class="mr-2">warning</v-icon>OFFLINE! Check your internet connection...
          </div>
          <div v-else class="width-full">
            <Tickers />
          </div>

          <flash-message transitionName="fade"></flash-message>
        </v-app-bar>
      </transition>

      <v-container
        v-if="authorized"
        class="fixed-margin"
        :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
        style="padding-bottom: 0px;padding-top: 0px"
      >
        <v-row v-if="$vuetify.breakpoint.lgAndUp">
          <v-col cols="12">
            <MenuMain />
          </v-col>
        </v-row>
        <v-app-bar
          v-else
          style="height:65px !important;background-color:#1E242E;padding:5px 0 5px 0; margin:0px;border:0px;"
          :flat="!scrolled"
          fixed
        >
          <v-container style="padding-bottom: 0px;padding-top: 0px">
            <v-row>
              <v-col cols="12">
                <MenuMain />
              </v-col>
            </v-row>
          </v-container>
        </v-app-bar>
      </v-container>

      <v-app-bar
        v-else
        style="height:60px !important;background-color:#1E242E; margin:0px;border:0px;"
        :flat="!scrolled"
        fixed
      >
        <v-container style="padding-bottom: 0px;padding-top: 0px">
          <v-row>
            <v-col cols="12">
              <MenuLanding />
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <transition name="slide-x-transition" mode="out-in">
        <div v-bind:style="$vuetify.breakpoint.lgAndUp ? '':'margin-top:60px'">
          <keep-alive>
            <router-view
              v-if="$route.meta.keepAlive"
              v-bind:style="authorized ? '':'margin-top:60px'"
              style="padding-bottom: 100px"
            ></router-view>
          </keep-alive>
          <router-view
            v-if="!$route.meta.keepAlive"
            v-bind:style="authorized ? '':'margin-top:60px'"
            style="padding-bottom: 100px"
          ></router-view>
        </div>
      </transition>
    </div>

    <div v-if="!loggedIn">
      <v-app-bar
        style="height:60px !important;background-color:#1E242E; margin:0px;border:0px;"
        :flat="!scrolled"
        fixed
      >
        <v-container style="padding-bottom: 0px;padding-top: 0px">
          <v-row>
            <v-col cols="12">
              <MenuLanding />
            </v-col>
          </v-row>
        </v-container>
      </v-app-bar>

      <transition name="component-fade" mode="out-in">
        <router-view v-if="!authorized" style="margin-top:90px;padding-bottom: 100px" />
      </transition>
    </div>
    <Footer />
  </v-app>
</template>

<script>
import Footer from "@/components/Footer";
import MenuMain from "@/components/MenuPool/";
import Tickers from "@/components/Tickers/";
import MenuLanding from "@/components/MenuLanding/";
export default {
  name: "App",

  metaInfo() {
    return {
      title: "TRADEinPOOL.com - Trading Framework",
      meta: [
        {
          name: "description",
          content:
            "Solution for personal and team trading data management. Log your steps realtime and get feedback using our trading framework immediately. We are leader on the way from trading anarchy to trading rules."
        },
        { property: "og:url", content: "https://tradeinpool.com/" },
        {
          property: "og:description",
          content:
            "Solution for personal and team trading data management. Log your steps realtime and get feedback using our trading framework immediately. We are leader on the way from trading anarchy to trading rules."
        },
        {
          property: "og:title",
          content: "TRADEinPOOL.com - Trading Framework"
        },
        { property: "og:site_name", content: "TRADEinPOOL.com" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content:
            "https://tradeinpool.com" + require("@/assets/img/facebook.png")
        },
        { name: "robots", content: "index,follow" }
      ]
    };
  },

  components: {
    MenuMain,
    MenuLanding,
    Footer,
    Tickers
  },
  data() {
    return {
      loaded: false,
      state: { online: navigator.onLine },
      scrolled: false
    };
  },
  created() {
    if (localStorage.getItem("access_token")) {
      this.$store
        .dispatch("getUserdata")
        .then(() => {})
        .catch(() => {
          this.$router.push({ name: "home" });
          alert("App loading API failed");
        });
    }
  },
  watch: {
    isOnline(newVal) {
      if (this.loaded && newVal) {
        location.reload();
      } else this.loaded = true;

      if (this.loaded && !newVal) {
        //alert("offline")
      }
    }
  },
  mounted: function() {
    var vm = this;

    window.addEventListener("scroll", function() {
      var scrollPos = window.scrollY;
      var winHeight = window.innerHeight;
      var docHeight = document.documentElement.scrollHeight; // instead document.body.clientHeight
      var perc = (100 * scrollPos) / (docHeight - winHeight);
      //vm.$el.style.width = perc + '%'
      if (perc == 0) vm.scrolled = false;
      else vm.scrolled = true;
    });
  },
  methods: {
    updateOnlineStatus() {
      const vm = this;
      if (this.state.online == false) {
        location.reload();
      }
      vm.state.online = navigator.onLine;
      alert(vm.state.online);
      ///if(vm.state.online) location.reload();
    },
    preventdrop: function(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  },
  computed: {
    authorized() {
      if (this.$route.meta.requiresAuth) return true;
      else return false;
    },
    userLoaded() {
      return this.$store.getters.userLoaded;
    },
    loggedIn() {
      return this.$store.getters.loggedIn;
    }
  },
  sockets: {
    markets: function(data) {
      alert(data);
    }
  }
};

/* HIDE INPUT DETAIL BOX
div.v-text-field__details {
  display: none;
}
*/
</script>

<style>
.v-app-bar {
  height: 55px !important;
}

.v-chip--no-color {
  background-color: #404855 !important;
}

.v-timeline-item__divider {
  height: 80px !important;
}

body {
  background-color: #1e242e;
  font-family: "Roboto", sans-serif;
}

.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
.custom.v-text-field > .v-input__control > .v-text-field__details {
  /*display: none;*/
}
.custom {
  padding: 0px;
}

.custom.v-timeline-item {
  padding: 0px 0px 16px !important;
}

.custom.v-timeline {
  padding-top: 16px !important;
}

.v-date-picker-table,
.v-date-picker-header,
.v-date-picker-years {
  background-color: #28303d !important;
  box-shadow: none !important;
}
.v-picker {
  box-shadow: none !important;
}
.v-application {
  color: white !important;
}

.v-badge__badge {
  max-height: 16px !important;
  min-width: 16px !important;
  padding: 0px !important;
  top: -12px !important;
  right: -18px !important;
}

.fixed-margin {
  margin-top: 40px;
}

.v-toolbar__items {
  height: 30px;
}
.col.col-12 {
  padding: 0px;
}
.v-toolbar__content {
  vertical-align: bottom;
}
.v-container {
  padding: 0px;
}
.v-card {
  background-color: #28303d !important;
  overflow: hidden;
}

.v-select__selections {
  font-size: 12px !important;
}

.timezone .v-select__selections {
  font-size: 12px !important;
  font-weight: bold !important;
}

.pre-trade div[role="button"] {
  margin-bottom: 0px;
  height: 30px;
  min-height: 30px;
}
.timeframe div[role="button"] {
  margin-bottom: 0px;
  height: 30px;
  min-height: 30px;
  width: 105px !important;
}

.strategyselector div[role="button"] {
  margin-bottom: 0px;
  height: 30px;
  min-height: 30px;
  width: 155px !important;
}

.v-chip__content {
  font-size: 12px;
}
.tag-chip .v-chip {
  background-color: #4dbac0 !important;
}

.v-chip--select {
  background-color: #4dbac0 !important;
}
.select-chips .v-chip {
  background-color: #2196f3 !important;
}
label.v-label {
  color: white !important;
  font-size: 12px;
  margin-left: 10px;
}

.v-list {
  background-color: #404855 !important;
}
div.v-list-item {
  font-size: 12px !important;
  height: 30px !important;
  min-height: 30px !important;
}
div.v-toolbar__content {
  padding: 0px;
  max-height: 64px;
}

.register .v-label {
  color: grey !important;
}

.zone-picker .v-select__slot {
  width: auto !important;
  padding: 0px !important;
  height: 10px !important;
  max-height: 10px !important;
}
.zone-picker .v-input__slot {
  padding: 0px !important;
  margin: 0px !important;
  height: 30px !important;
  min-height: 0px !important;
}
.zone-picker .v-input__control {
  height: 30px !important;
  min-height: 0px !important;
}
.zone-picker .v-input {
  padding: 0px !important;
  height: 10px !important;
  max-height: 10px !important;
}
.zone-picker .v-select__selections {
  height: 30px !important;
}
.zone-picker .v-select {
  width: 105px !important;
  min-width: 50px !important;
}
.zone-picker .v-input__append-inner {
  padding: 0px !important;
}
.zone-picker .v-input__icon {
  height: 8px !important;
}
.zone-picker .v-select__slot {
  padding-left: 10px !important;
  height: 10px !important;
  max-height: 10px !important;
}

/* Change Autocomplete styles in Chrome*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  /*border: 1px solid green;*/
  /*-webkit-text-fill-color: green;*/
  -webkit-box-shadow: 0 0 0px 1000px #b6c1cb inset;
  box-shadow: inset 0 0 6px #b6c1cb;
  transition: background-color 5000s ease-in-out 0s;
}

/* Change Autocomplete styles in Chrome*/
.edit input:-webkit-autofill,
.edit input:-webkit-autofill:hover,
.edit input:-webkit-autofill:focus,
.edit textarea:-webkit-autofill,
.edit textarea:-webkit-autofill:hover,
.edit textarea:-webkit-autofill:focus,
.edit select:-webkit-autofill,
.edit select:-webkit-autofill:hover,
.edit select:-webkit-autofill:focus {
  /*border: 1px solid green;*/
  /*-webkit-text-fill-color: green;*/
  -webkit-box-shadow: 0 0 0px 1000px #28303d inset;
  box-shadow: inset 0 0 6px #28303d;
  transition: background-color 5000s ease-in-out 0s;
}
.v-expansion-panel,
.v-expansion-panel-header .v-expansion-panels,
.v-data-table {
  background-color: #28303d !important;
}

tr:hover {
  background: #232a35 !important;
}

th {
  background: #232a35 !important;
}

.checklist th {
  background: #28303d !important;
}

.v-input--is-disabled {
  color: white !important;
}

.my-v-list .v-list-group__header {
  background-color: #404855 !important;
  padding-left: 0px;
}

.my-v-list .v-list-item__icon {
  margin-top: 3px;
  padding: 0px;
  left: 0px;
}
.v-skeleton-loader__bone {
  background-color: #28303d !important;
}
</style>